"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "user",
              "skeleton"
            ]);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Header-Admin.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    index_template = require("/workspace/src/views/components/Wrapper/index.marko"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    get_context_template = require("@marko-tags/context/src/components/get-context/index.marko"),
    get_context_tag = marko_loadTag(get_context_template),
    marko_attrs0 = {
        "class": "col"
      },
    marko_attrs1 = {
        "class": "mb-0"
      },
    marko_attrs2 = {
        "class": "col-md-4 d-md-block d-none"
      },
    marko_attrs3 = {
        "class": "cursor-pointer"
      },
    marko_attrs4 = {
        "class": "list-inline mt-1"
      },
    marko_attrs5 = {
        "class": "pr-2",
        style: "white-space:nowrap"
      },
    marko_attrs6 = {
        "class": "py-50",
        style: "white-space:nowrap"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("1be41e"),
    marko_node0 = marko_createElement("i", {
        "class": "bx bx-minus pl-4",
        style: "color:inherit"
      }, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "pr-2",
        style: "white-space:nowrap"
      },
    marko_attrs8 = {
        "class": "bx bx-minus pl-4",
        style: "color:inherit"
      };

function render(input, out, __component, component, state) {
  var data = input;

  get_context_tag({
      __from: index_template,
      renderBody: function(out, { page, ancestors }) {
        Row_tag({
            class: "position-sticky zindex-5 top-0 m-0 theme-bg d-flex align-items-center px-md-5 px-2 py-50",
            style: "min-height:8.8rem",
            renderBody: function(out) {
              out.be("div", marko_attrs0, "1", component);

              out.be("h4", marko_attrs1, "2", component);

              Locale_tag({
                  text: input.title || page.title
                }, out, __component, "3");

              out.ee();

              if (!input.nobreadcrump) {
                out.be("ul", marko_attrs4, "4", component);

                out.be("li", marko_attrs5, "5", component);

                route_link_tag({
                    href: "/",
                    class: "d-inline-flex align-items-center py-50",
                    renderBody: function(out) {
                      Locale_tag({
                          text: "Home"
                        }, out, __component, "7");

                      out.t(" ");

                      out.n(marko_node0, component);
                    }
                  }, out, __component, "6");

                out.ee();

                if (ancestors) {
                  marko_forOf(ancestors, function({ path, title }, index) {
                    var $keyValue$0 = "@" + index,
                        $keyScope$0 = "[" + ($keyValue$0 + "]");

                    out.be("li", marko_attrs7, $keyValue$0, component);

                    route_link_tag({
                        href: path,
                        class: "d-inline-flex align-items-center py-50",
                        renderBody: function(out) {
                          Locale_tag({
                              text: title
                            }, out, __component, "10" + $keyScope$0);

                          out.t(" ");

                          out.e("i", marko_attrs8, "11" + $keyScope$0, component, 0);
                        }
                      }, out, __component, "9" + $keyScope$0);

                    out.ee();
                  });
                }

                out.be("li", marko_attrs6, "12", component);

                Locale_tag({
                    text: (page.title.split(" ")[0] || "*").toCapitalCase()
                  }, out, __component, "13");

                out.ee();

                out.ee();
              }

              out.ee();

              out.be("div", marko_attrs2, "14", component);

              out.be("span", marko_attrs3, "15", component, null, 0, {
                  onclick: __component.d("click", () => window.Extensions.run('SuperProfile'), false)
                });

              Image_tag({
                  alt: getFullname(state.user),
                  src: state.user.photo,
                  class: "avatar float-right",
                  style: "width:3.4rem;height:3.4rem",
                  icon: "bx bx-user"
                }, out, __component, "16");

              out.ee();

              out.ee();
            }
          }, out, __component, "0");
      }
    }, out, __component, "17");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
